import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

const BILLING_METHODS = [
  {
    value: "Calendar Month Billing",
    label: "Calendar Month Billing",
    description: "Billing periods follow standard calendar months and always start on the 1st of the month.",
    example: "Jan 1–31, Feb 1–28",
  },
  {
    value: "30-Day Cycle Billing",
    label: "30-Day Cycle Billing",
    description: "Billing periods run in rolling 30-day cycles from a fixed start date, regardless of calendar months.",
    example: "Jan 10–Feb 8, Feb 9–Mar 10",
  },
  {
    value: "Anniversary Billing",
    label: "Anniversary Billing",
    description: "Billing periods start on the same day each month based on the billing anchor date.",
    example: "Feb 15–Mar 14, Mar 15–Apr 14",
  },
];

export default function BillingMethodSelectionModal({ open, onClose, currentValue, onSelect }) {
  const [selected, setSelected] = useState(currentValue || null);

  const handleCancel = () => {
    setSelected(currentValue || null);
    onClose();
  };

  const handleSelect = value => {
    setSelected(value);
    onSelect(value);
    onClose();
  };

  return (
    <Dialog
      open={open}
      maxWidth={false}
      onClose={handleCancel}
      PaperProps={{ sx: { width: "600px", maxWidth: "90vw" } }}
    >
      <DialogContent sx={{ bgcolor: "#f4f6f8" }}>
        <DialogContentText>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <Box width={40} />
            <Typography fontSize={22} fontWeight={400} textAlign="center">
              Select Billing Cycle
            </Typography>
            <IconButton color="textPrimary" onClick={handleCancel}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box display="flex" flexDirection="column" gap={1.5}>
            {BILLING_METHODS.map(method => {
              const isSelected = selected === method.value;
              return (
                <Paper
                  key={method.value}
                  onClick={() => handleSelect(method.value)}
                  elevation={isSelected ? 2 : 0}
                  sx={{
                    cursor: "pointer",
                    border: "2px solid",
                    borderColor: isSelected ? "primary.main" : "transparent",
                    transition: "border-color 0.15s, box-shadow 0.15s",
                    "&:hover": {
                      borderColor: isSelected ? "primary.main" : "grey.300",
                    },
                  }}
                >
                  <Box p={2} display="flex" alignItems="flex-start" gap={1.5}>
                    <Box sx={{ mt: 0.25, color: isSelected ? "primary.main" : "action.disabled" }}>
                      {isSelected ? (
                        <CheckCircleIcon fontSize="small" />
                      ) : (
                        <RadioButtonUncheckedIcon fontSize="small" />
                      )}
                    </Box>
                    <Box>
                      <Typography fontWeight={500} fontSize={15}>
                        {method.label}
                      </Typography>
                      <Typography fontSize={14} color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.5 }}>
                        {method.description}
                      </Typography>
                      <Typography fontSize={13} color="text.disabled" sx={{ mt: 0.5 }}>
                        Example: {method.example}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              );
            })}
          </Box>

        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
